import { EmployerType } from '@pflegia/types/api/employer/employer-type';

export const employerTypeEmoji = (employerType: EmployerType): string => {
  switch (employerType) {
    case EmployerType.Ambulant:
      return '🚗';
    case EmployerType.RehabClinic:
    case EmployerType.Hospital:
      return '🏥';
    case EmployerType.Intensive:
    case EmployerType.IntensiveAmbulant:
      return '💉';
    case EmployerType.Other:
    case EmployerType.Hospice:
    case EmployerType.NursingHome:
      return '🏠';
    default:
      return '🏥';
  }
};

export const employerTypeTitle = (employerType: EmployerType): string => {
  switch (employerType) {
    case EmployerType.Ambulant:
      return 'ambulantCare';
    case EmployerType.Hospital:
      return 'hospital';
    case EmployerType.RehabClinic:
      return 'rehabClinic';
    case EmployerType.Hospice:
      return 'hospice';
    case EmployerType.Intensive:
      return 'intensive';
    case EmployerType.IntensiveAmbulant:
      return 'intensiveAmbulant';
    case EmployerType.NursingHome:
      return 'nursingHome';
    case EmployerType.Leasing:
      return 'leasing';
    case EmployerType.DentalPractice:
      return 'dentalPractice';
    case EmployerType.DoctorOffice:
      return 'doctorOffice';
    case EmployerType.Physiotherapy:
      return 'physiotherapy';
    default:
      return 'other';
  }
};
